/* eslint-disable no-shadow */
import React, { Component, createRef, ReactNode } from "react";
import PropTypes from "prop-types";
import ReactPlayer from "react-player";
import Parser from "html-react-parser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import {
  Wrapper,
  Inner,
  Question,
  QuestionText,
  QuestionTextUnderline,
  Icon,
  AnswerWrapper,
  Answer,
  Text,
  VideoPlayerWrapper,
  VideoPlayerWrapperInner,
} from "./styles/guide-styles";

export interface IGuideProps {
  title?: string;
  content?: string;
  videoUrl?: string;
  index?: number;
  id?: string;
  key?: string;
}

interface IGuideState {
  isOpen: boolean;
  height?: number;
}

class Guide extends Component<IGuideProps, IGuideState> {
  static propTypes = {
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    videoUrl: PropTypes.string,
    index: PropTypes.number.isRequired,
    id: PropTypes.string.isRequired,
  };

  static defaultProps = {
    videoUrl: null,
  };

  private answerRef = createRef<HTMLDivElement>();

  constructor(props: IGuideProps) {
    super(props);

    this.state = { isOpen: false };
  }

  handleToggle = (e: { preventDefault: () => void }): void => {
    e.preventDefault();
    const { isOpen } = this.state;

    this.setState({
      height: this.answerRef.current.clientHeight,
      isOpen: !isOpen,
    });
  };

  render(): ReactNode {
    const { title, content, videoUrl, index, id } = this.props;
    const { height, isOpen } = this.state;
    const currentHeight = isOpen ? height + 40 : 0;

    return (
      <Wrapper>
        <Inner>
          <Question
            data-test-id={`question-${id}`}
            onClick={(e: { preventDefault: () => void }) =>
              this.handleToggle(e)
            }
            isOpen={isOpen}
          >
            <QuestionText>
              {index + 1}. {Parser(title)}
              <QuestionTextUnderline isOpen={isOpen} />
            </QuestionText>
            <Icon isOpen={isOpen}>
              <FontAwesomeIcon icon={faChevronDown} />
            </Icon>
          </Question>
          <AnswerWrapper style={{ height: `${currentHeight}px` }}>
            <Answer className={isOpen && "is-expanded"} ref={this.answerRef}>
              <Text isOpen={isOpen}>{Parser(content)}</Text>
              {videoUrl && (
                <VideoPlayerWrapper isOpen={isOpen}>
                  <VideoPlayerWrapperInner>
                    <ReactPlayer
                      url={videoUrl}
                      height="100%"
                      width="100%"
                      controls
                      config={{
                        file: {
                          attributes: {
                            controlsList: "nodownload",
                          },
                        },
                      }}
                    />
                  </VideoPlayerWrapperInner>
                </VideoPlayerWrapper>
              )}
            </Answer>
          </AnswerWrapper>
        </Inner>
      </Wrapper>
    );
  }
}

export default Guide;
